import { render } from "./DepartmentMobile.vue?vue&type=template&id=283f140a&scoped=true"
import script from "./DepartmentMobile.vue?vue&type=script&lang=js"
export * from "./DepartmentMobile.vue?vue&type=script&lang=js"

import "./DepartmentMobile.vue?vue&type=style&index=0&id=283f140a&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283f140a"]])

export default __exports__